// Force check for UpCart shipping protection toggle
// Targets: <label class="upcart-internal-addons__toggle-switch upcart-public-addons__toggle-switch"> <input type="checkbox"> ...
(function () {
  'use strict';

  const SELECTOR_LABEL = 'label.upcart-internal-addons__toggle-switch.upcart-public-addons__toggle-switch';

  function isElementVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      el.offsetWidth > 0 &&
      el.offsetHeight > 0
    );
  }

  function ensureChecked(input, label) {
    try {
      if (!input) return false;

      const alreadyChecked = !!input.checked || (input.getAttribute && input.getAttribute('aria-checked') === 'true');
      if (alreadyChecked) return true;

      // Prefer native user-like interactions first
      if (isElementVisible(input)) {
        input.click();
      } else if (label && isElementVisible(label)) {
        label.click();
      } else {
        // Fallback: set properties/attributes and dispatch events
        input.checked = true;
        if (input.setAttribute) input.setAttribute('aria-checked', 'true');
        try {
          const changeEvt = new Event('change', { bubbles: true });
          input.dispatchEvent(changeEvt);
          const inputEvt = new Event('input', { bubbles: true });
          input.dispatchEvent(inputEvt);
        } catch (e) {
          // Ignore event dispatch errors
        }
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function setToggleChecked(root) {
    try {
      const container = root || document;
      const labels = container.querySelectorAll(SELECTOR_LABEL);
      let changed = false;
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        const input = label ? label.querySelector('input[type="checkbox"]') : null;
        if (input) {
          const ok = ensureChecked(input, label);
          changed = changed || ok;
        }
      }
      return changed;
    } catch (_e) {
      return false;
    }
  }

  function debounce(fn, wait) {
    let t = 0;
    return function () {
      if (t) window.clearTimeout(t);
      const args = arguments;
      const ctx = this;
      t = window.setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function bootstrap() {
    // Initial attempt and short retries for dynamically loaded content
    var attempts = 0;
    var maxAttempts = 10;
    var intervalMs = 500;

    var intervalId = window.setInterval(function () {
      attempts++;
      var done = setToggleChecked(document);
      if (done || attempts >= maxAttempts) {
        window.clearInterval(intervalId);
      }
    }, intervalMs);

    // Observe DOM changes (cart drawers often mount later)
    try {
      const observer = new MutationObserver(
        debounce(function () { setToggleChecked(document); }, 150)
      );
      observer.observe(document.body, { childList: true, subtree: true });
    } catch (_e) {
      // Ignore if MutationObserver is unavailable
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
